import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-portrate'),_c('div',{staticClass:"m-2"},[_c('bread-crumbs',{attrs:{"items":_vm.items}}),_c('tabs-comp',{staticStyle:{"margin-top":"60px !important"},attrs:{"tabs":_vm.tabs}}),_c(VRow,{staticClass:"m-2"},[_c(VCol,{attrs:{"cols":"12"}})],1),_c('products-addcats',{ref:"AddCategory"})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }